// extracted by mini-css-extract-plugin
export default {"title":"_542bedac87","inner_title":"cce0ea70e7","charge_btn":"_4084ee7fd1"};